import { createFileRoute } from "@tanstack/react-router";
import { AuthShell } from "@/components/auth/AuthShell";
import { BRAND } from "@/config";

const RESULTS = {
  connected: {
    title: "Stripe connected ✓",
    body: `Your Stripe account is now connected to ${BRAND.appName}. ${BRAND.name} payments will arrive in this account. You can close this page.`,
  },
  cancelled: { title: "Not connected", body: "The Stripe connection was cancelled. Open the link again to retry." },
  expired: { title: "Link expired", body: "This connection link is no longer valid. Please ask for a new one." },
  error: { title: "Not connected", body: "Stripe could not complete the connection. Please ask for a new link." },
} as const;

// Landing page for the stripe-oauth-callback edge function (links Steve's Stripe account).
export const Route = createFileRoute("/stripe-connected")({
  validateSearch: (search: Record<string, unknown>) => ({
    result: (typeof search.result === "string" && search.result in RESULTS ? search.result : "error") as keyof typeof RESULTS,
  }),
  component: StripeConnected,
});

function StripeConnected() {
  const { result } = Route.useSearch();
  const r = RESULTS[result];
  return (
    <AuthShell title={r.title}>
      <p className="text-sm leading-relaxed text-white/80">{r.body}</p>
    </AuthShell>
  );
}
